import { marketPlans } from '../../../mocks/market';

const habitLabels: Record<string, string> = {
  timeManagement: '时间管理',
  studyFocus: '学习专注',
  lifeCare: '生活自理',
  sportsHealth: '运动健康',
  responsibility: '责任担当',
  etiquette: '言行礼仪'
};

const habitColors: Record<string, string> = {
  timeManagement: 'bg-orange-100 text-orange-600',
  studyFocus: 'bg-violet-100 text-violet-600',
  lifeCare: 'bg-emerald-100 text-emerald-600',
  sportsHealth: 'bg-amber-100 text-amber-600',
  responsibility: 'bg-rose-100 text-rose-600',
  etiquette: 'bg-teal-100 text-teal-600'
};

export default function MarketSection() {
  const featured = marketPlans.slice(0, 6);

  return (
    <section id="market" className="py-20 md:py-28 bg-gradient-to-b from-[#EFF6FF] to-[#DBEAFE]">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-blue-100 text-blue-700 text-sm px-4 py-2 rounded-full mb-4 font-medium">
            <i className="ri-store-3-fill"></i>
            <span>激励市场</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-blue-900 mb-4">精选家庭激励方案</h2>
          <p className="text-gray-500 text-lg">来自真实家庭的实战经验，一键导入即可使用</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {featured.map(plan => (
            <div key={plan.id} className="bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-all duration-200 border border-blue-100">
              {/* Header */}
              <div className="p-5 pb-3">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <img src={plan.avatar} alt={plan.author} className="w-10 h-10 rounded-xl object-cover object-top" />
                    <div>
                      <div className="font-bold text-blue-900 text-sm">{plan.title}</div>
                      <div className="text-xs text-gray-400">{plan.author}</div>
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    {plan.tags.filter(t => t !== '王牌').map(tag => (
                      <span key={tag} className={`text-[10px] px-2 py-0.5 rounded-full font-bold whitespace-nowrap ${
                        tag === 'VIP' ? 'bg-gradient-to-r from-amber-400 to-orange-500 text-white' :
                        tag === '热门' || tag === '爆款' ? 'bg-red-100 text-red-600' :
                        tag === '推荐' ? 'bg-blue-100 text-blue-600' :
                        'bg-gray-100 text-gray-500'
                      }`}>{tag}</span>
                    ))}
                  </div>
                </div>
                <p className="text-xs text-gray-500 leading-relaxed mb-3">{plan.description}</p>
                <div className="flex flex-wrap gap-1 mb-3">
                  {plan.habitTags.map(h => (
                    <span key={h} className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${habitColors[h] || 'bg-gray-100 text-gray-500'}`}>
                      {habitLabels[h]}
                    </span>
                  ))}
                </div>
              </div>

              {/* Stats */}
              <div className="px-5 pb-3">
                <div className="grid grid-cols-3 gap-2 bg-blue-50 rounded-xl p-3">
                  <div className="text-center">
                    <div className="text-sm font-black text-blue-900">{plan.rulesCount}</div>
                    <div className="text-[10px] text-gray-400">条规则</div>
                  </div>
                  <div className="text-center border-x border-blue-100">
                    <div className="text-sm font-black text-emerald-600">{plan.improvementRate}%</div>
                    <div className="text-[10px] text-gray-400">改善率</div>
                  </div>
                  <div className="text-center">
                    <div className="text-sm font-black text-orange-600">{plan.usageCount.toLocaleString()}</div>
                    <div className="text-[10px] text-gray-400">家庭使用</div>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="px-5 pb-4 flex items-center justify-between">
                <div className="flex items-center gap-1">
                  <i className="ri-star-fill text-amber-400 text-sm"></i>
                  <span className="text-sm font-bold text-gray-700">{plan.rating}</span>
                  <span className="text-xs text-gray-400">· 约{plan.avgDays}天见效</span>
                </div>
                {plan.isFree ? (
                  <button className="whitespace-nowrap text-xs font-bold px-4 py-2 rounded-xl transition-all cursor-pointer bg-gradient-to-r from-emerald-400 to-teal-500 text-white hover:shadow-md">
                    免费导入
                  </button>
                ) : (
                  <span className="flex items-center gap-1.5 text-xs font-black px-3 py-1.5 rounded-xl bg-gradient-to-r from-amber-400 to-orange-500 text-white whitespace-nowrap cursor-default">
                    <i className="ri-vip-crown-fill text-xs"></i>VIP专属
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-2xl border-2 border-blue-300 text-blue-600 font-bold hover:bg-blue-50 transition-colors cursor-pointer">
            <i className="ri-store-3-line"></i>
            浏览全部方案
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
